export default __webpack_public_path__ + "static/media/icon-clock.19e6b6ae.svg";